import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import CancelIcon from '@material-ui/icons/Cancel';
import SaveIcon from "@material-ui/icons/Save";
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow
} from '@material-ui/core';
import { add_showroom_special_timetable_demo } from '../../../../api/API';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
    root: {},

    saveButton: {
        color: theme.palette.white,
        backgroundColor: colors.green[600],
        '&:hover': {
            backgroundColor: colors.green[900]
        },

    },

    flexend: {
        justifyContent: 'flex-end',
    },
    leftIcon: {
        marginRight: theme.spacing.unit,
    },
}));

export default function Form(props) {

    const { profile, className, showroom_agencies, is_special, ...rest } = props;

    const classes = useStyles();

    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [agencies, setAgencies] = useState(showroom_agencies);
    const [max_appointment, setMaxAppointment] = useState(props.max_appointment);
    const [timeslots, setTimeslots] = useState([]);
    const [values, setValues] = useState({
        day: 0,
        type: 1,
        property_id: props.showroom_id,
        is_special: is_special,
        date: moment(new Date()).format("yyyy-MM-DD")
    });

    useEffect(() => {
        console.log("timeslots changed", timeslots);
    }, [timeslots]);
    useEffect(() => {
        setAgencies(props.showroom_agencies);
        setMaxAppointment(props.max_appointment);

        let extra_values = {};
        for (let i = 0; i < props.showroom_agencies.length; i++) {
            extra_values['agency_slot_' + props.showroom_agencies[i].agency_id] = "0";
        }
        setValues({
            ...values,
            ...extra_values
        });

    }, []);

    const history = useHistory();

    const handleChange = event => {
        // event.persist();

        setValues({
            ...values,
            [event.target.name]:
                event.target.type === 'checkbox'
                    ? event.target.checked
                    : event.target.value
        });

    };

    const checkTotalAppointment = () => {
        let total_agency_booking = 0;
        for (let i = 0; i < agencies.length; i++) {
            if (values['agency_slot_' + agencies[i].agency_id]) {
                total_agency_booking += parseInt(values['agency_slot_' + agencies[i].agency_id]);
            }
        }
        console.log("Total : " + total_agency_booking);
        console.log("max : " + max_appointment);
        if (total_agency_booking > max_appointment) {
            alert("Total number of appointments must not exceed " + max_appointment);
            return false;
        }

        return true;

    }

    const handleSubmit = async event => {
        event.preventDefault();

        if (!validate_timeslot_values()) {
            return;
        }
        if (is_special && values.title == "") {
            alert("Please enter a title");
            return;
        }
        if (checkTotalAppointment()) {
            var post_data = {
                property_id: values.property_id,
                timeslots: JSON.stringify(timeslots),
                is_special: 1,
                special_date: values.date,
                special_title: values.title

            };
            let res = await add_showroom_special_timetable_demo(post_data);
            // add_showroom_timetable_demo(values);
            if (res) {
                history.push("/showroom/detailshowroom/" + props.showroom_id);
            }

        }
    };

    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };

    // const day = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

    const handleAddTimeslot = event => {
        var all_timeslots = [...timeslots];
        console.log(all_timeslots);
        var timeslots_temp = {
            type: values.type,
            start: '',
            end: '',
            fcfs_appointment: max_appointment
        };

        var default_vals = null;

        for (var i = all_timeslots.length - 1; i >= 0; i--) {
            if (all_timeslots[i].type == values.type) {
                default_vals = all_timeslots[i];
                break;
            }
        }
        agencies.map((agency) => {
            timeslots_temp['agency_' + agency.agency_id] = {
                agency_id: agency.agency_id,
                value: default_vals ? default_vals['agency_' + agency.agency_id].value : 0
            };
        });

        if (all_timeslots) {
            all_timeslots.push(timeslots_temp);
        } else {
            all_timeslots = [timeslots_temp];
        }
        setTimeslots(all_timeslots);
    };

    const handleRemoveTimeslot = (timeslot_index) => {
        var all_timeslots = [...timeslots];
        all_timeslots.splice(timeslot_index, 1);
        setTimeslots(all_timeslots);
    }

    const validate_timeslot_values = () => {
        var all_timeslots = [...timeslots];
        var check = true;

        for (var timeslot_index = 0; timeslot_index < all_timeslots.length; timeslot_index++) {
            var timeslot_row = all_timeslots[timeslot_index];
            var total_appt = 0;
            for (var agency_index = 0; agency_index < agencies.length; agency_index++) {
                total_appt += parseInt(timeslot_row['agency_' + agencies[agency_index].agency_id].value);

                if (total_appt > max_appointment) {
                    all_timeslots[timeslot_index]['agency_' + agencies[agency_index].agency_id].error = "Max appt " + max_appointment;
                    check = false;
                } else {
                    all_timeslots[timeslot_index]['agency_' + agencies[agency_index].agency_id].error = "";
                }
            }
        }
        console.log("F ", all_timeslots);

        setTimeslots(all_timeslots);
        return check;
    };
    const handleChangeSlotValue = (e, type, timeslot_index, agency_index = 0) => {
        var all_timeslots = [...timeslots];
        if (type == "allocation") {
            if (all_timeslots[timeslot_index].type == '1') {
                all_timeslots[timeslot_index]['agency_' + agency_index].value = e.target.value;
            } else {
                all_timeslots[timeslot_index].fcfs_appointment = e.target.value;
            }

        } else if (type == "slot") {
            all_timeslots[timeslot_index][e.target.name] = e.target.value;
        }

        setTimeslots(all_timeslots);
        validate_timeslot_values();


    }
    return (
        <div>
            <form onSubmit={handleSubmit}>
                <Card
                    {...rest}
                    className={clsx(classes.root, className)}
                >
                    <CardHeader title="Create New Timetable" />
                    <Divider />
                    <CardContent>
                        <Grid
                            container
                            spacing={4}
                        >
                            {is_special ?
                                <React.Fragment>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >
                                        <TextField
                                            fullWidth
                                            label="Title"

                                            required={is_special ? 1 : 0}
                                            name="title"
                                            onChange={handleChange}
                                            value={values.title}
                                            variant="outlined"
                                        >

                                        </TextField>
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}
                                    >
                                        <TextField
                                            fullWidth
                                            label="Date"
                                            name="date"
                                            type="date"
                                            onChange={handleChange}
                                            value={values.date}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        >
                                        </TextField>
                                    </Grid>
                                </React.Fragment>
                                : ''}
                            <Grid
                                item
                                md={6}
                                xs={12}
                            >
                                <TextField
                                    fullWidth
                                    label="Type"
                                    name="type"
                                    select
                                    onChange={handleChange}
                                    value={values.type}
                                    variant="outlined"
                                >
                                    <option
                                        key="1"
                                        value="1"
                                    >
                                        Pre-allocated
                                    </option>
                                    <option
                                        key="2"
                                        value="2"
                                    >
                                        First come first serve
                                    </option>
                                </TextField>
                            </Grid>

                        </Grid>
                        <br></br>
                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end"
                        }}>
                            <Button
                                variant="contained"
                                onClick={handleAddTimeslot}
                            >
                                <AddIcon></AddIcon> Add Timeslot
                            </Button>
                        </div>
                        <br></br>
                        <hr></hr>
                        <br></br>

                        <React.Fragment>
                            <Table className="wide">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{
                                            textAlign: "center"
                                        }} colSpan="2">Timeslot</TableCell>
                                        {agencies.map(agency => (
                                            <TableCell>{agency.name}</TableCell>
                                        ))}
                                        <TableCell></TableCell>

                                    </TableRow>
                                </TableHead>
                                {timeslots.map((slot, slot_index) => (
                                    <React.Fragment>
                                        {slot.type == '1' ? (
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            label="Start Time"
                                                            name="start"
                                                            onChange={(e) => {
                                                                handleChangeSlotValue(e, "slot", slot_index);
                                                            }}
                                                            type="time"
                                                            step="15"
                                                            value={slot.start}
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            label="End Time"
                                                            name="end"
                                                            onChange={(e) => {
                                                                handleChangeSlotValue(e, "slot", slot_index);
                                                            }}
                                                            type="time"
                                                            step="15"
                                                            value={slot.end}
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </TableCell>
                                                    {agencies.map(row => (
                                                        <TableCell>
                                                            <TextField
                                                                type="number"
                                                                style={{
                                                                    textAlign: "center"
                                                                }}
                                                                error={slot['agency_' + row.agency_id].error}
                                                                helperText={slot['agency_' + row.agency_id].error}
                                                                value={slot['agency_' + row.agency_id].value}
                                                                label="slots"
                                                                name={"agency_slot_" + row.agency_id}
                                                                onChange={(e) => {

                                                                    handleChangeSlotValue(e, 'allocation', slot_index, row.agency_id)
                                                                }}
                                                            ></TextField>
                                                        </TableCell>
                                                    ))}
                                                    <TableCell>
                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: "black"
                                                            }}

                                                            onClick={() => {
                                                                handleRemoveTimeslot(slot_index);
                                                            }}
                                                        >
                                                            <CancelIcon

                                                            ></CancelIcon>
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ) :
                                            (
                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth
                                                                label="Start Time"
                                                                name="start"
                                                                onChange={(e) => {
                                                                    handleChangeSlotValue(e, "slot", slot_index);
                                                                }}
                                                                type="time"
                                                                step="15"
                                                                value={slot.start}
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <TextField
                                                                fullWidth
                                                                label="End Time"
                                                                name="end"
                                                                onChange={(e) => {
                                                                    handleChangeSlotValue(e, "slot", slot_index);
                                                                }}
                                                                type="time"
                                                                step="15"
                                                                value={slot.end}
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell colSpan={agencies.length}>
                                                            <TextField
                                                                type="number"
                                                                InputProps={{
                                                                    readOnly: true
                                                                }}
                                                                style={{
                                                                    textAlign: "center",
                                                                    width: "100%"
                                                                }}
                                                                value={slot.fcfs_appointment}
                                                                label="First Come First Serve"
                                                                name={'FCFS'}
                                                                onChange={(e) => {
                                                                    handleChangeSlotValue(e, 'allocation', slot_index)
                                                                }}
                                                            ></TextField>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button
                                                                variant="contained"
                                                                style={{
                                                                    backgroundColor: "black"
                                                                }}

                                                                onClick={() => {
                                                                    handleRemoveTimeslot(slot_index);
                                                                }}
                                                            >
                                                                <CancelIcon

                                                                ></CancelIcon>
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableBody>
                                            )}
                                    </React.Fragment>
                                )
                                )}
                            </Table>
                            <div className="mobile">
                                {timeslots.map((slot, slot_index) => (
                                    <React.Fragment>
                                        {slot.type == '1' ? (
                                            <React.Fragment>
                                                <Grid container>
                                                    <Grid item xs={12} style={{ textAlign: "right" }}>
                                                        <Button
                                                            variant="contained"
                                                            style={{
                                                                backgroundColor: "black",
                                                                marginTop: 10,
                                                                marginBottom: 10
                                                            }}

                                                            onClick={() => {
                                                                handleRemoveTimeslot(slot_index);
                                                            }}
                                                        >
                                                            <CancelIcon

                                                            ></CancelIcon>
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                                <Grid spacing={1} container>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            label="Start Time"
                                                            name="start"
                                                            onChange={(e) => {
                                                                handleChangeSlotValue(e, "slot", slot_index);
                                                            }}
                                                            type="time"
                                                            step="15"
                                                            value={slot.start}
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            fullWidth
                                                            label="End Time"
                                                            name="end"
                                                            onChange={(e) => {
                                                                handleChangeSlotValue(e, "slot", slot_index);
                                                            }}
                                                            type="time"
                                                            step="15"
                                                            value={slot.end}
                                                            variant="outlined"
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </Grid>

                                                </Grid>
                                                <Grid container spacing={1}>

                                                    {agencies.map(row => (
                                                        <Grid item xs={6}>
                                                            <TextField
                                                                type="number"
                                                                style={{
                                                                    textAlign: "center"
                                                                }}
                                                                error={slot['agency_' + row.agency_id].error}
                                                                helperText={slot['agency_' + row.agency_id].error}
                                                                value={slot['agency_' + row.agency_id].value}
                                                                label={row.name}
                                                                name={"agency_slot_" + row.agency_id}
                                                                onChange={(e) => {

                                                                    handleChangeSlotValue(e, 'allocation', slot_index, row.agency_id)
                                                                }}
                                                            ></TextField>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </React.Fragment>
                                        ) :
                                            (
                                                <React.Fragment>
                                                    <Grid container>
                                                        <Grid item xs={12} style={{ textAlign: "right" }}>
                                                            <Button
                                                                variant="contained"
                                                                style={{
                                                                    backgroundColor: "black",
                                                                    marginTop: 10,
                                                                    marginBottom: 10
                                                                }}

                                                                onClick={() => {
                                                                    handleRemoveTimeslot(slot_index);
                                                                }}
                                                            >
                                                                <CancelIcon

                                                                ></CancelIcon>
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid spacing={1} container>
                                                        <Grid item xs={6}>
                                                            <TextField
                                                                fullWidth
                                                                label="Start Time"
                                                                name="start"
                                                                onChange={(e) => {
                                                                    handleChangeSlotValue(e, "slot", slot_index);
                                                                }}
                                                                type="time"
                                                                step="15"
                                                                value={slot.start}
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <TextField
                                                                fullWidth
                                                                label="End Time"
                                                                name="end"
                                                                onChange={(e) => {
                                                                    handleChangeSlotValue(e, "slot", slot_index);
                                                                }}
                                                                type="time"
                                                                step="15"
                                                                value={slot.end}
                                                                variant="outlined"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </React.Fragment>

                                            )}
                                    </React.Fragment>
                                )
                                )}
                            </div>
                        </React.Fragment>

                    </CardContent>
                </Card>

                <Card
                    {...rest}
                    className={clsx(classes.root, className)}
                >
                    <Divider />
                    <CardActions className={classes.flexend}>
                        <Button
                            variant="contained"
                            style={{
                                backgroundColor: "black"
                            }}
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            <CancelIcon className={classes.leftIcon} />
                        Cancel
                </Button>
                        <Button
                            className={classes}
                            type="submit"
                            variant="contained"

                        >
                            <SaveIcon className={classes.leftIcon} />
                            Save Changes
                </Button>
                    </CardActions>
                    {/* <SuccessSnackbar
            onClose={handleSnackbarClose}
            open={openSnackbar}
            /> */}
                </Card>

            </form>
        </div>
    )
}